/*
 * Copyright (c) 2026 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import type { ReactNode } from 'react';
import { AuthProvider as KitAuthProvider, type AuthAccount } from '@vaas/react-ui-kit/auth';

import { authMode, msalInstance } from './msalConfig';

/** Mock signed-in user for local dev; GMIN defaults to a dev-DB row unless overridden. */
const MOCK_USER: AuthAccount = {
  id: 'dev',
  name: 'Dev User',
  username: 'dev@localhost',
  gmin: import.meta.env.VITE_MOCK_GMIN ?? '521426832',
};

/**
 * MSAL when configured; mock session for local dev. The token/claims bridge is wired at boot in
 * {@link registerAuthBridge} (before first render) so requests never race ahead of the token.
 */
export function AuthProvider({ children }: { children: ReactNode }) {
  return (
    <KitAuthProvider
      mode={authMode}
      instance={msalInstance}
      mockUser={MOCK_USER}
      mockInitialSignedIn={authMode === 'mock'}
    >
      {children}
    </KitAuthProvider>
  );
}
